import React, { useEffect, useState } from "react";
import { Item } from "../../interfaces/interfaces";
import classNames from "classnames";
import style from "./SectionItems.module.scss";
import { Skeleton } from "@mui/material";
import SkeletonItem from "../Rows/SkeletonRow/components/SkeletonItem";
import RowItem from "../Rows/Row/components/RowItem/RowItem";
import { useSearchParams } from "react-router-dom";
import { EParams } from "../../interfaces/enum";
import API from "../../api/api";

type SectionItemProps = {
  title: string;
  items: Item[];
  isTrending: boolean;
  loading: boolean;
};

const SectionItems = ({
  title,
  items,
  isTrending,
  loading,
}: SectionItemProps) => {
  const [showingItems, setShowingItems] = useState(items);
  const [sectionLoading, setSectionLoading] = useState(loading);
  const [params] = useSearchParams({});
  const q = params.get(EParams.QUERY);

  useEffect(() => {
    if (!q || q?.length === 0) {
      setShowingItems(items);
      return;
    }
    API.getQueryItems(q || "").then((res: any) => {
      setSectionLoading(true);
      setShowingItems(res);
      setInterval(() => {
        setSectionLoading(false);
      }, 2000);
    });
  }, [items, q]);

  useEffect(() => {
    setSectionLoading(loading);
  }, [loading]);
  return (
    <div>
      <div>
        <div className={classNames(style.title)}>
          {sectionLoading && (
            <Skeleton
              variant="text"
              className={classNames(style.skeleton, style.titleSkeleton)}
            />
          )}
          {!sectionLoading && showingItems.length !== 0 && (
            <>{q ? `Searching for "${q}"` : title}</>
          )}
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div className={classNames(style.itemsContainer)}>
            {sectionLoading &&
              Array.from(new Array(8)).map((i, index) => {
                return (
                  <div key={index} className={style.itemContainer}>
                    <SkeletonItem isTrending={isTrending} />
                  </div>
                );
              })}
            {!sectionLoading && showingItems.length !== 0 && (
              <>
                {showingItems.map((item, index) => {
                  return (
                    <div key={index} className={style.itemContainer}>
                      <RowItem data={item} isTrending={false} />
                      <div className={classNames(style.allInfo)}>
                        <div
                          className={classNames(style.info)}
                          dangerouslySetInnerHTML={{
                            __html: `${item.year} &#x2022; ${item.category} &#x2022; ${item.rating}`,
                          }}
                        />
                        <div className={classNames(style.infoTitle)}>
                          {item.title}
                        </div>
                      </div>
                    </div>
                  );
                })}{" "}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionItems;
